import { useState } from 'react';

import { useSelector } from 'react-redux';
import { selectUserToken } from '../../../../redux/features/user/userSelectors';
import { useGetPinCandidatesQuery } from '../../../../redux/services/realties/realtiesApi';
import { useDebounce } from '../../../../hooks/useDebounce';

import { SearchItem } from '../../../form/search/realties/SearchItem';
import { Loader } from '../../Loader';

const MIN_QUERY_LENGTH = 3;

export const RealtyPinPicker = ({ onPick }) => {
  const userToken = useSelector(selectUserToken);

  const [inputValue, setInputValue] = useState('');
  const searchQuery = useDebounce(inputValue.trim(), 500);

  const hasQuery = searchQuery.length >= MIN_QUERY_LENGTH;

  const { data: realties = [], isFetching } = useGetPinCandidatesQuery(
    { token: userToken, searchQuery },
    { skip: !hasQuery }
  );

  return (
    <div className="flex flex-col gap-2 w-full">
      <input
        type="text"
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        placeholder="Search by ID, name, address…"
        className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded outline-none focus:border-gray-500"
      />

      {hasQuery && (
        <div className="relative flex flex-col max-h-64 min-h-16 overflow-y-auto border border-gray-200">
          {isFetching && (
            <div className="absolute inset-0 flex items-center justify-center bg-white/60">
              <Loader
                width={32}
                height={32}
              />
            </div>
          )}

          {!isFetching && realties.length === 0 && (
            <p className="p-3 text-xs text-gray-500 text-center">
              No realties found
            </p>
          )}

          {realties.map(realty => (
            <SearchItem
              key={realty.id}
              item={realty}
              handleItemClick={() => onPick(realty)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
